import BaseBlockMap from './BaseBlockMap';
import ChequingBlockMap from './ChequingBlockMap';
import CreditCardsBlockMap from './CreditcardsBlockMap';
import GicsBlockMap from './GicsBlockMap';
import InsuranceBlockMap from './InsuranceBlockMap';
import SavingsBlockMap from './SavingsBlockMap';


export default {
    ...BaseBlockMap,
    ...ChequingBlockMap,
    ...CreditCardsBlockMap,
    ...GicsBlockMap,
    ...InsuranceBlockMap,
    ...SavingsBlockMap,
};
